import React, {useState, useEffect, Fragment, useRef } from 'react';
import { connect } from 'react-redux';
import Slider from 'react-slick';
import { compose, withProps } from 'recompose';
import { Modal, Dropdown, OverlayTrigger, Tooltip, Container, Row, Col } from 'react-bootstrap';
import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import {notification, Rate, Empty} from 'antd';
import { Redirect, Link, useHistory } from 'react-router-dom';
import Scholarships_bg from '../../assets/img/scholarships_bg.jpg';
import CampsUser from '../../assets/img/camps-user.png';
import setting from '../../config/settings';
import { GiCampfire } from "react-icons/gi";
import { FaUser } from "react-icons/fa";
import {
  BsPeople,
  BsClock,
  BsAward,
  BsShield,
} from "react-icons/bs";

import {
    viewProgramDetail,
    getCartItemsNonLoginUser,
    getCartItems,
    addToCart,
    programFavourite,
    followcamps,
    userguest,
    addToCartNonLoginUser,
    getReview
} from '../../services/programService';
import { gradeArr2, getExperience, getProgramType, getFacility, getTravel, getTshirt, TRAVEL_NEEDS_INFO, SCHOLARSHIP_HAS_URL, gerFavprogrmdateFromFormatted, getHtml, urlify } from '../../helper';
import { LogoWhite, ProgramLoader,CardLoader } from '../reuse/SVG';
import { campContectAction, toggleMapViewModal, viewLoginModalAction } from '../../store/ui';
import AssociatedCard from './AssociatedCard';
import {getitemsincart} from '../../store/cart'
import {askQuestionService} from '../../services/otherService';
import Share from '../static/Share';
import moment from 'moment';
import { useGA4CampTracking } from '../../hooks/useGA4CampTracking';

const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
};


const MapComponent = compose(
    withProps({
      containerElement: <div style={{ height: `180px` }} />,
      mapElement: <div style={{ height: `100%` }} />,
    }),
    withGoogleMap
  )((props) =>
    <GoogleMap
      defaultZoom={12}
      defaultCenter={{lng: props.geoLocation ? props.geoLocation[0] : 0, lat: props.geoLocation ? props.geoLocation[1] : 0 }}
      >
            <Marker
              position={{lng: props.geoLocation ? props.geoLocation[0] : 0, lat: props.geoLocation ? props.geoLocation[1] : 0 }}
              icon={{
                url: require('../../assets/img/mapIcon.svg')
                }}
            >
            </Marker>
    </GoogleMap> 
  );


const CampDetail = props => {
    const todayDate2 = new Date().getTime();
    let history                                             = useHistory();
    const[loader, setLoader]                                = useState(true);
    const[programactionloader, setProgramActionLoader]      = useState(false);
    const[numberofCampers, setNumberOfCampers]              = useState(1);
    const[addtocartModal, setaddtocartModal]                = useState(false);
    const[campDetails, setCampDetails]                      = useState([]);
    const[campPrograms, setCampPrograms]                    = useState([]);
    const[additionalExp, setAdditionalExp]                  = useState();
    const[redirect, setRedirect]                            = useState(false);
    const[isFavouritecamp, setIsFavourite]                  = useState();
    const[isFollowed, setIsFollowed]                        = useState();
    const[btnloder, setBtnLoader]                           = useState(false);
    const[isAddedToCart, setIsAddedToCart]                  = useState(false);
    const[isConfirmed, setIsConfirmed]                      = useState(false);
    const[question, setQuestion]                            = useState('');
    const[btnDisable, setBtnDisable]                        = useState(false);
    const[reviews, setReviews]                              = useState([]);
    const[averageCampRating, setAverageCampRating]          = useState(0);
    const[viewAllModal, setViewAllModal]                    = useState(false);
    const[scholarships, setScholarships]                    = useState('');
    const[scholarshipsUrl, setScholarshipsUrl]              = useState('');
    const[others, setOthers]                                = useState([]);
    const[additionalDates, setAdditionalDates]              = useState([]);
    const[selectedDates, setSelectedDates]                  = useState([]);
    const[byDates, setByDates]                              = useState(2);
    const[showSelectDateModal, setShowSelectDateModal]      = useState(false);
    const [maxSlots, setMaxSlots]                           = useState(1);
    const [showError, setShowError]                         = useState(false);
    const [showScheduleModal, setShowScheduleModal]         = useState(false);
    const [isMobile, setIsMobile]                           = useState(window.innerWidth < 992);
    const [showMobileReg, setShowMobileReg]                 = useState(false);
    const photoRef                                          = useRef(null);
    const buttonRef                                         = useRef(null);
    const [isFloating, setIsFloating]                       = useState(false);
    const [isBigScreenFloating, setIsBigScreenFloating]     = useState(false);
    const [btnTop, setBtnTop]                               = useState(null);
    const [selectedExperience, setSelectedExperience]       = useState(null);
    const [isPhone, setIsPhone]                             = useState(window.innerWidth < 768);
    const [isTablet, setIsTablet]                           = useState(window.innerWidth >= 768 && window.innerWidth < 992);

    // Fire GA4 only if this program belongs to a tracked camp AND is upcoming (startDate in future).
    // campDetails starts as [] so campDetails.startDate is undefined — hook stays silent until API loads.
    // If campCode is not in CAMP_GA4_MAP the hook silently does nothing.
    const isUpcoming = campDetails.startDate > Date.now();
    useGA4CampTracking(
        isUpcoming ? campDetails.campCode : null,
        {
            program_code: campDetails.programCode,
            program_name: campDetails.programName,
            program_price: campDetails.registrationFee,
            // camp_name: campDetails.campName,
            // category: campDetails.categoryName,
            page_type: 'camp_detail',
        }
    );

    const onChangeSelectedDates = item => {
        let temp = [...selectedDates];
        if(temp.includes(item)){
            let new_temp = temp.filter(i => i !== item) 
            setSelectedDates(new_temp)
            const total_slots = Math.min(...new_temp.map((i) => i.slots));
            setMaxSlots(total_slots);
        }else{
            temp.push(item);
            setSelectedDates(temp);
            const total_slots = Math.min(...temp.map((i) => i.slots));
            setMaxSlots(total_slots);
        }
    } 


    useEffect(() => {
       setNumberOfCampers(1);
    }, [selectedDates])


    useEffect(() => {
        if(props.mapViewModal){
            props.toggleMapViewModal()
        }
        
    }, [])

    useEffect(() => {
        const onScroll = () => {
            if (!photoRef.current) return;
            if (!buttonRef.current) return;

            const rect = photoRef.current.getBoundingClientRect();
            const scroll = buttonRef.current.getBoundingClientRect();
            const imageFullyAboveViewport = rect.bottom <= 0;
            const buttonFullyAboveViewport = scroll.bottom <= 0;
            setIsFloating(imageFullyAboveViewport);
            setIsBigScreenFloating(buttonFullyAboveViewport);
        };

        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const getTotalPrice = items => {
        let temp = 0;
        if(items.length){
            items.map(i => temp += i.standardPrice);
            if(temp > 0){
                return `Price : $${temp.toFixed(2)}`
            }else {
                return 'Free'
            }
        }else {
            return ''
        }
        
    }

    function cleanHtml(htmlString) {
        if (!htmlString) return "";

        // Step 1: Create a temporary DOM parser
        const temp = document.createElement("div");
        temp.innerHTML = htmlString;

        // Step 2: Remove <p><br></p> and empty paragraphs
        temp.querySelectorAll("p").forEach((p) => {
            if (!p.textContent.trim()) p.remove();
        });

        // Step 3: Remove duplicated consecutive paragraphs
        const paragraphs = temp.querySelectorAll("p");
        for (let i = 0; i < paragraphs.length - 1; i++) {
            if (paragraphs[i].innerText.trim() === paragraphs[i + 1].innerText.trim()) {
                paragraphs[i + 1].remove();
            }
        }

        return temp.innerHTML;
    }

    useEffect(() => {
        const sidebar = document.querySelector(".sticky_sidebar");
        if (!sidebar) return;

        const timer = setTimeout(() => {
            sidebar.classList.add("loaded");
        }, 100);

        return () => clearTimeout(timer);
    }, [campDetails]);

    useEffect(() => {
        if(campDetails.campId){
            let query =`?campId=${campDetails.campId}`
            getReview(query).then(res => {
                if(res?.data?.statusCode){
                    setReviews(res.data.responseData.result);
                    setAverageCampRating(res.data.responseData.averageCampRating);
                }
            })
        }
        
    }, [campDetails])


    useEffect(() => {
        let userId = props.userID;
        let params ='';
       if(userId)
       {
          params = `?userId=${userId}&programId=${props.match.params.id}`;    
       }
       else
       {
        params = `?programId=${props.match.params.id}`; 
       }

        let program_details = viewProgramDetail(params);
        program_details.then((res)=>{
            setLoader(false)  
            if(res?.data?.statusCode){
                
                setCampDetails(res.data.responseData.result.programData);
                setCampPrograms(res.data.responseData.result.campPrograms);
                setIsFavourite(res.data.responseData.result.programData.isFavourite)
                setIsFollowed(res.data.responseData.result.programData.isFollowed)
                setScholarships(res.data.responseData.result.programData.scholarships);
                setScholarshipsUrl(res.data.responseData.result.programData.scholarshipsUrl);
                setOthers([...res.data.responseData.result.programData.personnel, ...res.data.responseData.result.programData.counselor]);
                setByDates(res.data.responseData.result.programData.byDates);
                res.data.responseData.result.programData.byDates === 2 && setMaxSlots(res.data.responseData.result.programData?.availableSlots);
                setNumberOfCampers(res.data.responseData.result.programData.numberOfBooking || 1);
                if(res.data.responseData.result.programData.byDates === 1){
                    let _additionalDates = res.data.responseData.result.programData.additionalDates.filter(mi => mi.slots > 0 && new Date() < mi.endDate);
                    let _selectedDate = res.data.responseData.result.programData.selectedDates;
                    setAdditionalDates(_additionalDates || []);
                    let _selectedDate2 = [];
                    if(_selectedDate?.length){
                        for (let i = 0; i < _additionalDates.length; i++) {
                            if(_selectedDate.includes(_additionalDates[i]._id)){
                                _selectedDate2.push(_additionalDates[i]);
                            }
                          }

                          setSelectedDates(_selectedDate2);
                    }
                    
                }
             
                let registrationStataus = 'booking';
                
                let registerOpenDate = res.data.responseData.result.programData.registerOpenDate
                let registrationCloseDate = res.data.responseData.result.programData.registerCloseDate 
                
                let dateEarlyRegisterOpen = res.data.responseData.result.programData.dateEarlyRegisterOpen;
                let dateEarlyRegisterClosed = res.data.responseData.result.programData.dateEarlyRegisterClosed;
                
                let dateLateRegisterOpen = res.data.responseData.result.programData.dateLateRegisterOpen;
                let dateLateRegisterClosed = res.data.responseData.result.programData.dateLateRegisterClosed;
                
                let time = new Date();
                let todaydate = time.getTime();

                if(dateEarlyRegisterOpen!==undefined && todaydate<dateEarlyRegisterOpen)
                {
                    registrationStataus = 'commingsoon';
                }else{
                    if(todaydate<dateEarlyRegisterOpen)
                    {
                        registrationStataus = 'commingsoon'; 
                    }
                    if(todaydate > dateEarlyRegisterClosed && todaydate<registerOpenDate)
                    {
                        registrationStataus = 'commingsoon';  
                    }
                }

                if(dateLateRegisterClosed!==undefined && todaydate > dateLateRegisterClosed)
                {
                    registrationStataus = 'closed';  
                }
                else
                {
                    if(todaydate > dateLateRegisterClosed)
                    {
                        registrationStataus = 'closed'; 
                    }
                    if(todaydate < dateLateRegisterOpen && todaydate > registrationCloseDate)
                    {
                        registrationStataus = 'commingsoon';    
                    }  
                }
            


                let tax = res.data.responseData.result.programData.tax;
                let registrationfee = res.data.responseData.result.programData.registrationFee;
                let convenienceFee = res.data.responseData.result.programData.convenienceFee;
                let discounttype = res.data.responseData.result.programData.discountType;
                let discountamount = res.data.responseData.result.programData.discount;
                let campamount = '';
                let taxamont  = res.data.responseData.result.programData.taxPrice;
                if(discounttype===1)
                {
                    campamount = registrationfee + discountamount  - taxamont - convenienceFee;
                    
                }
                else{
                    campamount = registrationfee + discountamount  - taxamont - convenienceFee;
                    discountamount = registrationfee*discountamount/100;
                }
                
               
               
                if(res.data.responseData.result.programData.isCartConfirmed){
                    setIsConfirmed(true)   
                }
                if(res.data.responseData.result.programData.isAddedToCart){
                    setIsAddedToCart(true)
                }
                let additionexp = res.data.responseData.result.programData.additionalExp;
                
                let additionalobj ={}
                if(additionexp !== undefined)
                {
                additionexp.map((item,index) => {
                    let key = index;
                    additionalobj[key] = {"_id": item._id, "quantity":0, "price":item.price,"title": item.title}
                    if(item.description !== undefined)
                    {
                        additionalobj[key].description = item.description;   
                    }
                })
                setAdditionalExp(additionalobj);
                }

                let _campContect = {
                    campPhone: res.data.responseData.result.programData.campPhone, 
                    campEmail: res.data.responseData.result.programData.campEmail
                }

                props.campContectAction(_campContect)


                }else{
                    history.push("/camps")
                }         
        })


        return () => {
            props.campContectAction({})
        }

       
       
    }, [])

    useEffect(() => {
        const handleResize = () =>{
            setIsMobile(window.innerWidth < 992);
            const width = window.innerWidth;
            setIsPhone(width < 768);
            setIsTablet(width >= 768 && width < 992);
        }
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


     /*******Add to cart for non login users***** */
     const addtocartAction = async(programid, numberofcampers, buttontype, programDetailIsCommuter) =>
     {

        let service = props.loggedIn ? getCartItems : getCartItemsNonLoginUser
        setBtnLoader(true);
        if(props.loggedIn){
            let programId = programid;
            let numberOfBooking = numberofcampers;
            let params = {programId, numberOfBooking, fromProgramDetail: 1, programDetailIsCommuter};
            if(byDates === 1){
                let _selectedDatesIds = selectedDates.map(i => i._id);
                params.selectedDates = JSON.stringify(_selectedDatesIds);
            }
            
            let src;
            let sku;
            let footballCamps_gl;
            const trafficSource = JSON.parse(
                localStorage.getItem('traffic_source')
            );
            if( trafficSource ){
                let sourceMetadata = {};
                src = trafficSource.source;
                sku = trafficSource.sku;
                footballCamps_gl = trafficSource._gl;
                let referralSource = src;
                let footballCampsSku = sku;
                let _gl = footballCamps_gl;
                if( referralSource ){
                    sourceMetadata.referralSource = referralSource;
                }
                if( footballCampsSku ){
                    sourceMetadata.footballCampsSku = footballCampsSku;
                }
                if( _gl ){
                    sourceMetadata._gl = _gl;
                }
                params.sourceMetadata = sourceMetadata;
            }

            addToCart(params).then(res => {
                if(res.data.statusCode === 1){
                    service().then(res=>{
                        
                        if(res?.data?.statusCode){
                            props.getitemsincart(res.data.responseData.result.length)
                        }
                    })

                    if(buttontype === 'addtocart2'){
                        history.push({
                            pathname: '/profile/information',
                            state: {
                                "numbderofCampers": 1,
                                "cart_id": res.data.responseData.cartId
                            }
                        })
                    }

                    if(buttontype === 'addtocart'){
                            setaddtocartModal(true);
                            setBtnLoader(false);
                            setIsAddedToCart(true)
                        }else{
                            setRedirect(true);
                        }
                }else{
                    if(res.data.error.errorCode === 25){
                        history.push("/cart")
                    }
                }
            });  
        }
        else
        {
        let nonLoginaccessToken = localStorage.getItem('NonLoginaccessToken'); 
           if(!nonLoginaccessToken)
           {
            let guestuser = await userguest()
            try{
                if(guestuser.data.statusCode===1)
                {
                    localStorage.setItem('NonLoginaccessToken', guestuser.data.responseData.accessToken);
                    localStorage.setItem('NonLoginUserID', guestuser.data.responseData.userProfile._id);
                    let programId = programid;
                    let numberOfBooking = numberofcampers;
                    let params = {programId, numberOfBooking}  
                    addToCartNonLoginUser(params).then(res=>{
                        if(res?.data?.statusCode)
                        {
                            if(buttontype==='addtocart')
                                {
                                    setaddtocartModal(true);
                                    setBtnLoader(false);
                                    setIsAddedToCart(true)
                                }    
                                else
                                {
                                    setRedirect(true);
                                }
                                service().then(res=>{
                                    if(res?.data?.statusCode)
                                    {
                                        props.getitemsincart(res.data.responseData.result.length)
                                    }
                                })
                        }
                    });
                }
            }catch(error){}            
           } 
           else
           {
               let programId = programid;
               let numberOfBooking = numberofcampers;
               let params = {programId, numberOfBooking}  
               addToCartNonLoginUser(params).then(res=>{
                if(res?.data?.statusCode)
                {
                    if(buttontype==='addtocart')
                        {
                            setaddtocartModal(true);
                            setBtnLoader(false);
                        }    
                        else
                        {
                            setRedirect(true);
                        }
                        service().then(res=>{
                            if(res?.data?.statusCode)
                            {
                                props.getitemsincart(res.data.responseData.result.length)
                            }
                        })
                }
            });
           }

            const oldproduct = localStorage.getItem('cartitems') ? localStorage.getItem('cartitems') : "[]";
            const arrayproduct =  JSON.parse(oldproduct);  
            if(arrayproduct.length>0)
            {
                let prevaddproducts = arrayproduct.filter(cartitems => cartitems.programId ===programid);
                if(prevaddproducts.length>0)
                {
                    let prevaddproductquantity = prevaddproducts[0].numberOfBooking+1;
                    let index = arrayproduct.findIndex(cartitems => cartitems.programId ===programid);
                    arrayproduct[index].numberOfBooking = prevaddproductquantity;
                    localStorage.setItem('cartitems', JSON.stringify(arrayproduct)); 
                }
                else
                { 
                    let additional_exp_cart = [];
                
                    if(additionalExp)
                    {
                        for (const property in additionalExp) { 
                                let addition_exp = {"_id" : additionalExp[property]._id,"price": additionalExp[property].price, "title":additionalExp[property].title }
                                if( additionalExp[property].description !== undefined)
                                {
                                    addition_exp.description = additionalExp[property].description;   
                                }
                                additional_exp_cart.push(addition_exp);
                        }
                    }                    
                    
                let cartdata ={"programId":programid,"numberOfBooking":numberofCampers, "additionalExperience": additional_exp_cart, "registrationFee": campDetails.registrationFee, "convenienceFee": campDetails.convenienceFee, "programName": campDetails.programName, "startDate": campDetails.startDate, "endDate":campDetails.endDate}
                arrayproduct.push(cartdata);
                localStorage.setItem('cartitems', JSON.stringify(arrayproduct));  
                }
                setBtnLoader(false);
            }
            else
            {
                let additional_exp_cart = [];
                
                if(additionalExp)
                {
                    for (const property in additionalExp) { 
                            let addition_exp = {"_id" : additionalExp[property]._id,"price": additionalExp[property].price, "title":additionalExp[property].title }
                            if( additionalExp[property].description !== undefined)
                            {
                                addition_exp.description = additionalExp[property].description;   
                            }
                            additional_exp_cart.push(addition_exp);
                    }
                }

               // let cartdata ={"programID":programid,"numberOfBooking":numberofCampers, "additionalExperience": additional_exp_cart}
                

                let cartdata ={"programId":programid,"numberOfBooking":numberofCampers, "additionalExperience": additional_exp_cart, "registrationFee": campDetails.registrationFee, "convenienceFee": campDetails.convenienceFee }

                arrayproduct.push(cartdata);
                localStorage.setItem('cartitems', JSON.stringify(arrayproduct)); 
                setBtnLoader(false);
            }
        }
        
       



    }


    const handleFavourite = (programId, favourite) => {
        setProgramActionLoader(true);
        let params = {
            programId: programId,
            favourite: favourite
        }

        programFavourite(params).then(res => {
            setProgramActionLoader(false);
            setIsFavourite(favourite);
        })
    }
    const followCamps = async(campId,follow) => {
        setProgramActionLoader(true);
        const followCamp = await followcamps({campId,follow});
        try{
            if(follow){
                setIsFollowed(true);
                setProgramActionLoader(false);
                notification.open({
                    description: 'You started following this camp ',
                });
            }else{
                setIsFollowed(false);
                setProgramActionLoader(false);
                notification.open({
                    description: 'You started unfollow this camp ',
                });

            }
        }
        catch(err){
           
        } 
    }  

    const handleMultiDateCheck = (actionFn) => {
        if (byDates === 1 && selectedDates.length === 0) {
            setShowSelectDateModal(true);
            return;
        }
        actionFn();
    };


    const handleQuestionSubmit = () => {

        if(question !== ''){
            setBtnDisable(true);
            let params = {
                question, 
                programId: campDetails._id,
                email: props.userProfile.email
            }
            askQuestionService(params).then(res => {
                setBtnDisable(false);
                if(res?.data?.statusCode){
                    setQuestion('');
                    notification.open({
                        description:
                          'Question Submitted',
                      });
                }
            })
        }
    }
  
    const onNumberOfCampersUpdate = (type) => {
        setShowError(false);
        switch (type) {
            case 'add':
                setNumberOfCampers(numberofCampers < maxSlots ? numberofCampers + 1 : maxSlots);
                break;
            case 'remove':
                setNumberOfCampers(numberofCampers > 1 ? numberofCampers - 1 : 1);
                break;
            case 'default':
                console.log('error in the updating counts')
                break;
        }
        let errorCount = numberofCampers + 1;
        if (errorCount > maxSlots) {
            setShowError(true);
        }
        setIsAddedToCart(false)

    }

    const handleRegister = (options = {}) => {
        if (isAddedToCart) {
            // Already in cart → go directly
            props.history.push("/cart");
            return;
        }

        // Flag to pre define user selection between over night camp or commuter
        let programDetailIsCommuter = options.programDetailIsCommuter ?? false;

        addtocartAction(
            campDetails._id, 
            numberofCampers, 
            "proceedTocheckout",
            programDetailIsCommuter
        );
    };

    useEffect(() => {
        setTimeout(() => {
            document.querySelector(".sticky_sidebar")?.classList.add("loaded");
        }, 50);
    }, []);

    if (redirect)
    return (<Redirect to='/cart'  />)
  
    const hasOvernight = campDetails.disableOvernight !== true;
    // earlyBirdCommuterPrice / lateCommuterPrice are optional per-tier overrides. A program
    // may carry one of those without a standard commuterPrice, so testing commuterPrice
    // alone hides the Commuter Option on programs that genuinely offer it.
    const hasCommuter = (campDetails.commuterPrice || campDetails.earlyBirdCommuterPrice
                         || campDetails.lateCommuterPrice || 0) > 0;
    const optionCount = (hasOvernight ? 1 : 0) + (hasCommuter ? 1 : 0);
    // Browse-side prices, pre-discount: the active tier + registerNonRefundFee, with a special
    // deal applied. The discount is deducted at checkout, where the cart itemises it, so these
    // are the figures that match the cart's "Camp Registration Fee" line rather than the payable
    // total in campDetails.registrationFee — the page used to advertise the payable total and
    // undercut its own program card by the discount. The fallbacks keep the old client-side
    // expressions, so this renders sensibly against an API without the fields.
    const overnightTotal = campDetails.campRegistrationFee ?? (campDetails.registrationFee || 0);
    const commuterTotal = campDetails.commuterCampRegistrationFee
        ?? ((campDetails.commuterPrice || 0) + (campDetails.registerNonRefundFee || 0));

    // A byDates program advertises its blocks fee-inclusive, the way a single-date program
    // advertises its tier price, so the two kinds of card are comparable. The fee is charged once
    // per camper rather than once per block, so picking two blocks costs less than the two rows
    // add up to — hence the note under the list.
    const nonRefundFee = campDetails.registerNonRefundFee || 0;
    const datePriceWithFee = block => (block.standardPrice || 0) + nonRefundFee;
    // Server-computed: the cheapest still-bookable block plus the fee. Taking Math.min over
    // additionalDates here instead produced Infinity once every block was sold out or past.
    const byDatesStartingFrom = campDetails.campRegistrationFee || 0;
    const showByDatesPrice = byDates === 1 && additionalDates.length > 0;

    return(
        <>
            <div className="body_container program_page">

                <div className="container">
                    <Modal
                        dialogClassName="h_auto"
                        show={addtocartModal}
                        animation={false}
                        centered
                    >
                    <Modal.Body>
                        <div className="p-5">
                            <h3 className="text-center mb-4">Success!</h3>
                            <p className="text-center">Successfully added to cart </p>
                            <button onClick={()=>setaddtocartModal(false)}className="btn btn-primary w-100 mt-2">Ok</button>
                        </div>
                    </Modal.Body>
                    </Modal>



                    <Modal
                        dialogClassName="h_auto"
                        show={showSelectDateModal}
                        animation={false}
                        centered
                    >
                    <Modal.Body>
                        <div className="p-5">
                            <h3 className="text-center mb-4">Warning!</h3>
                            <p className="text-center">Please Select Program Date</p>
                            <button onClick={()=> setShowSelectDateModal(false)}className="btn btn-primary w-100 mt-2">Close</button>
                        </div>
                    </Modal.Body>
                    </Modal>

                    <Modal
                        dialogClassName="h_auto"
                        show={showScheduleModal}
                        animation={false}
                        centered
                    >
                        <Modal.Body>
                            <span 
                                className="modal_close" 
                                onClick={() => setShowScheduleModal(false)}
                            >
                                <i className="icon-cross" />
                            </span>

                            <h3 className="mb-3">Sample Schedule</h3>

                            <ul className="daily_schedule_list">
                                {campDetails.schedule && campDetails.schedule.length ? (
                                    campDetails.schedule.map(item => (
                                        <li key={item.time} className="schedule_row">
                                            <div className="schedule_icon">
                                                <BsClock size={20} color="#C63D3D" />
                                            </div>

                                            <div className="schedule_time">
                                                <b>{item.time}</b>
                                            </div>

                                            <div className="schedule_activity">
                                                {item.activity}
                                            </div>
                                        </li>
                                    ))
                                ) : (
                                    <li className="empty_row">Not updated</li>
                                )}
                            </ul>
                        </Modal.Body>
                    </Modal>

                    <div className="d-flex justify-content-between program_head">
                        <div>
                        <div className='d-flex align-items-center' >
                            <img src={campDetails.campLogo} className="camp_logo" alt="camplogo"/>
                            <h2 className='ms-3'>{campDetails.campName} - {campDetails.programName}</h2>
                        </div>
                        </div>
                        {/* <div className="text-center">
                            <div className="ratings">
                                <span>EZPro: </span>
                                <span className="icon-star" />
                                <span className="icon-star" />
                                <span className="icon-star" />
                                <span className="icon-star" />
                                <span className="icon-star" />
                            </div>
                            <small>({campDetails.ratingCount} reviews)</small>
                        </div> */}
                    </div>


                    <div className="row">
                        <div className="col-lg-8 prog_main">

                            {/* <div className="prog_media">
                            {campDetails.isSpecialDeal ? <span className="SD_tag">Special Offers</span> :''}
                            {programactionloader ? <CardLoader/>: ''}
                                {campDetails.programImages && campDetails.programImages.length ? <Slider {...settings}>
                                                        {campDetails.programImages.map(item => (
                                                            <div className="prog_slide_img" key={item._id}>
                                                                <img src={item.url} className="img-fluid" />
                                                            </div>
                                                        ))}
                                                    </Slider> : <div className="no_img"><LogoWhite /></div>
                                }

                                {
                                props.userID ? isFollowed ? 
                                <i onClick={()=> {followCamps(campDetails.campId,0)}} className="cm_follow icon-check"/> : 
                                <i onClick={()=> {followCamps(campDetails.campId,1)}} className="cm_follow icon-plus" />:
                                ''
                                }

                            <div className="prog_action">
                                {
                                props.userID ? isFavouritecamp ? 
                                <i  onClick={()=>handleFavourite(campDetails._id, 0)} className="icon-heart active" /> : 
                                <i onClick={()=>handleFavourite(campDetails._id, 1)} className="icon-heart" /> : ''    
                                }
                                <Share pageUrl={`ProgramDetail=${props.match.params.id}`} />    
                                
                                        
                            
                            </div>                      
                            </div> */}






                            <Container 
                            style={{height:"400", width:'660'}}
                            
                            className="prog_media prog_media_desk">
                            {campDetails.isSpecialDeal ? <span className="SD_tag">Special Offers</span> :''}
                            {programactionloader && <CardLoader/> }
                                {campDetails?.programImages?.filter(i => !i.viewType)?.length ?
                                    <Slider {...settings}>
                                        {campDetails.programImages.filter(i => !i.viewType).map(item => (
                                            <div className="prog_slide_img" key={item._id}>
                                                <img src={item.url} className="img-fluid" alt=""/>
                                            </div>
                                        ))}
                                    </Slider>
                                    :
                                    campDetails.programImages?.length ?
                                        <Slider {...settings}>
                                            {campDetails.programImages.map(item => (
                                                <div className="prog_slide_img_secondary" key={item._id}>
                                                    <img src={item.url} className="img-fluid" alt=""/>
                                                </div>
                                            ))}
                                        </Slider>
                                        :
                                        campDetails.programImage ?
                                            <img src={campDetails.programImage} className="img-fluid" alt=""/>
                                            : <div className="no_img"><LogoWhite /></div>
                                }

                                {
                                props.userID ? isFollowed ? 
                                <i onClick={()=> {followCamps(campDetails.campId,0)}} className="cm_follow icon-check"/> : 
                                <i onClick={()=> {followCamps(campDetails.campId,1)}} className="cm_follow icon-plus" />:
                                ''
                                }

                            <div className="prog_action">
                                {
                                props.userID ? isFavouritecamp ? 
                                <i  onClick={()=>handleFavourite(campDetails._id, 0)} className="icon-heart active" /> : 
                                <i onClick={()=>handleFavourite(campDetails._id, 1)} className="icon-heart" /> : ''    
                                }
                                <Share pageUrl={`ProgramDetail=${props.match.params.id}`} />    
                            
                            </div>                      
                            </Container>




                            <div className="prog_media prog_media_mob" ref={photoRef}>
                            {campDetails.isSpecialDeal ? <span className="SD_tag">Special Offers</span> :''}
                            {programactionloader ? <CardLoader/>: ''}
                                {campDetails?.programImages?.filter(i => i.viewType)?.length ?
                                    <Slider {...settings}>
                                        {campDetails.programImages.filter(i => i.viewType).map(item => (
                                            <div className="prog_slide_img" key={item._id}>
                                                <img src={item.url} className="img-fluid" alt=""/>
                                            </div>
                                        ))}
                                    </Slider>
                                    :
                                    campDetails.programImages?.length ?
                                        <Slider {...settings}>
                                            {campDetails.programImages.map(item => (
                                                <div className="prog_slide_img" key={item._id}>
                                                    <img src={item.url} className="img-fluid" alt=""/>
                                                </div>
                                            ))}
                                        </Slider>
                                        : campDetails.programImage ?
                                            <img src={campDetails.programImage} className="img-fluid" alt=""/>
                                            : <div className="no_img"><LogoWhite /></div>
                                }

                                {
                                props.userID ? isFollowed ? 
                                <i onClick={()=> {followCamps(campDetails.campId,0)}} className="cm_follow icon-check"/> : 
                                <i onClick={()=> {followCamps(campDetails.campId,1)}} className="cm_follow icon-plus" />:
                                ''
                                }

                            <div className="prog_action">
                                {
                                props.userID ? isFavouritecamp ? 
                                <i  onClick={()=>handleFavourite(campDetails._id, 0)} className="icon-heart active" /> : 
                                <i onClick={()=>handleFavourite(campDetails._id, 1)} className="icon-heart" /> : ''    
                                }
                                <Share pageUrl={`ProgramDetail=${props.match.params.id}`} />    
                                
                                        
                            
                            </div>                      
                            </div>

                            {/* ---------- DATE + ADD TO CART + PROCEED TO CHECKOUT ---------- */}

                            <div className={`prog_header_row d-flex align-items-center mt-3 mb-3 ${byDates === 1 ? "multi_date_mode" : "justify-content-between"}`} ref={buttonRef}>

                                {/* LEFT — DATE */}
                                <div className="date_text me-3">
                                    <h3 className="m-0">
                                        {byDates === 1 ? "" : (() => {
                                            const days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
                                            const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
                                            const [sy, sm, sd] = (campDetails.startDateFormatted || '').split('-').map(Number);
                                            const [ey, em, ed] = (campDetails.endDateFormatted || '').split('-').map(Number);
                                            if (!sy) return '';
                                            const sDay = days[new Date(sy, sm - 1, sd).getDay()];
                                            const eDay = days[new Date(ey, em - 1, ed).getDay()];
                                            const sdStr = String(sd).padStart(2, '0');
                                            const edStr = String(ed).padStart(2, '0');
                                            if (sy === ey && sm === em && sd === ed)
                                                return `${months[sm - 1]} ${sdStr}, ${sy} (${sDay})`;
                                            if (sm === em)
                                                return `${months[sm - 1]} ${sdStr}-${edStr}, ${sy} (${sDay}-${eDay})`;
                                            return `${months[sm - 1]} ${sdStr} - ${months[em - 1]} ${edStr}, ${ey} (${sDay}-${eDay})`;
                                        })()}
                                    </h3>
                                </div>

                                {/* RIGHT — Add to Cart */}
                                {byDates !==1 && (
                                    <div className={`cart_btn_wrapper d-flex ${byDates !== 1 ? "justify-content-center flex-grow-1" : ""}`}>

                                        {isConfirmed ? (
                                            <Link
                                                to="/cart"
                                                className={`btn btn-primary btn-sm ${(isMobile || isTablet) ? "rounded-btn" : "rounded-desktop-btn" }`}
                                            >
                                                Proceed to checkout
                                            </Link>
                                        ) : (
                                            <button
                                                className={`btn btn-info btn-sm ${isMobile ? "rounded-mob-btn" : isTablet ? "rounded-btn" : "rounded-desktop-btn" }`}
                                                onClick={() =>
                                                    handleMultiDateCheck(() =>
                                                        props.loggedIn
                                                            ? addtocartAction(
                                                                campDetails._id,
                                                                numberofCampers,
                                                                "addtocart"
                                                            )
                                                            : props.viewLoginModalAction()
                                                    )
                                                }
                                            >
                                                Add to Cart
                                            </button>
                                        )}
                                    </div>
                                )}

                                {byDates === 1 && !isMobile && !isTablet && (
                                    <div className={`cart_btn_wrapper d-flex ${byDates !== 1 ? "justify-content-center flex-grow-1" : "justify-content-center flex-grow-1"}`}>

                                        {isConfirmed ? (
                                            <Link
                                                to="/cart"
                                                className="btn btn-primary btn-sm rounded-desktop-btn"
                                            >
                                                Proceed to checkout
                                            </Link>
                                        ) : (
                                            <button
                                                className="btn btn-info btn-sm rounded-desktop-btn"
                                                onClick={() =>
                                                    handleMultiDateCheck(() =>
                                                        props.loggedIn
                                                            ? addtocartAction(
                                                                campDetails._id,
                                                                numberofCampers,
                                                                "addtocart"
                                                            )
                                                            : props.viewLoginModalAction()
                                                    )
                                                }
                                            >
                                                Add to Cart
                                            </button>
                                        )}
                                    </div>
                                )}

                                {/* --- MULTI-DATE MOBILE/TABLET: put both on same row --- */}
                                {byDates === 1 && ((isMobile && !isFloating) || (isTablet && !isBigScreenFloating)) && (
                                    <div className={`${isTablet ? "tablet_btn_row" : "mobile_btn_row" }`}>
                                        {/* Add to Cart */}
                                        {isConfirmed ? (
                                            <Link
                                                to="/cart"
                                                className={`btn btn-primary btn-sm ${isTablet ? "rounded-bydate-btn" : "rounded-mob-bydate-btn" } add_cart_mobile_btn`}
                                            >
                                                Proceed to checkout
                                            </Link>
                                        ) : (
                                            <button
                                                className={`btn btn-info btn-sm ${isTablet ? "rounded-bydate-btn" : "rounded-mob-bydate-btn" } add_cart_mobile_btn`}
                                                onClick={() =>
                                                    handleMultiDateCheck(() =>
                                                        props.loggedIn
                                                            ? addtocartAction(campDetails._id, numberofCampers, "addtocart")
                                                            : props.viewLoginModalAction()
                                                    )
                                                }
                                            >
                                                Add to Cart
                                            </button>
                                        )}

                                        {/* Register now */}
                                        <button
                                            className={`${isTablet ? "mobile_reg_tab_byDate_static_btn" : "mobile_reg_byDate_static_btn" }`}
                                            onClick={() => setShowMobileReg(true)}
                                        >
                                            Register Now
                                        </button>
                                    </div>
                                )}

                                {/* --- SINGLE-DATE MODE --- */}
                                {byDates !== 1 && (isMobile && !isFloating) && (
                                    <button
                                        className="mobile_reg_static_btn"
                                        onClick={() => setShowMobileReg(true)}
                                    >
                                        Register Now
                                    </button>
                                )}

                                {byDates !== 1 && (isTablet && !isBigScreenFloating) && (
                                    <button
                                        className="mobile_reg_tab_static_btn"
                                        onClick={() => setShowMobileReg(true)}
                                    >
                                        Register Now
                                    </button>
                                )}

                            </div>

                            {(showError) && <span style={{ color: 'red' }}>Not enough slots available</span>}
                            

                            <div className="mt-4 mb-4 program_detail">
                                <h3>Program Details</h3>

                                <div className="row mt-3 g-3 no-bottom-gap">

                                    {/* ------------- THE BASICS ------------- */}
                                    <div className="col-lg-3 col-md-6">
                                        <div className="pd_card h-100">
                                            <div className="pd_header">
                                                <BsPeople className="icon" size={22} color="#C63D3D" style={{ marginRight: "10px" }} />
                                                <h4>The Basics</h4>
                                            </div>

                                            {campDetails.districtName ? (
                                                <p><b>District Name:</b> {campDetails.districtName}</p>
                                            ) : null}

                                            <p><b>Age Group:</b> {campDetails.minAge} - {campDetails.maxAge}</p>

                                            <p>
                                                <b>Sex:</b>{" "}
                                                {campDetails.gender === 1 && "Male"}
                                                {campDetails.gender === 2 && "Female"}
                                                {campDetails.gender === 3 && "Co-Ed"}
                                            </p>

                                            <p className="last_dot">
                                                <b>Grade:</b>{" "}
                                                {campDetails.grade &&
                                                    gradeArr2
                                                        .filter(el => campDetails.grade.find(e => el.value === e))
                                                        .sort((a, b) => a.count - b.count)
                                                        .map(item => (
                                                            <Fragment key={item.value}>
                                                                {item.value}
                                                                <span>, </span>
                                                            </Fragment>
                                                        ))}
                                            </p>

                                            <p><b>Experience:</b> {campDetails.expLevel ? getExperience(campDetails.expLevel) : "N/A"}</p>
                                        </div>
                                    </div>

                                    {/* ------------- YOUR STAY ------------- */}
                                    <div className="col-lg-3 col-md-6">
                                        <div className="pd_card h-100">
                                            <div className="pd_header">
                                                <BsClock className="icon" size={22} color="#C63D3D" style={{ marginRight: "10px" }} />
                                                <h4>Your Stay</h4>
                                            </div>

                                            <p><b>Check in Time:</b> {campDetails.checkInTime}</p>
                                            <p><b>Check out Time:</b> {campDetails.checkOutTime}</p>
                                            <p 
                                                className="sample_schedule_link"
                                                onClick={() => setShowScheduleModal(true)}
                                            >
                                                <span className="red_text">Click for</span>
                                                <span className="red_text">Sample Schedule</span>
                                            </p>

                                        </div>
                                    </div>

                                    {/* ------------- EXTRAS ------------- */}
                                    <div className="col-lg-3 col-md-6">
                                        <div className="pd_card h-100">
                                            <div className="pd_header">
                                                <BsAward className="icon" size={22} color="#C63D3D" style={{ marginRight: "10px" }} />
                                                <h4>Extras</h4>
                                            </div>

                                            <p><b>Travel:</b> {getTravel(campDetails.travel)}</p>

                                            <p><b>T-Shirt:</b> {getTshirt(campDetails.tShirt)}</p>

                                            <p className="last_dot">
                                                <b>Meals Provided:</b>{" "}
                                                {campDetails.meals && campDetails.meals.length
                                                    ? campDetails.meals.map(item => (
                                                        <Fragment key={item}>
                                                            {item}
                                                            <span>, </span>
                                                        </Fragment>
                                                    ))
                                                    : "None"}
                                            </p>
                                        </div>
                                    </div>

                                    {/* ------------- PROGRAM ------------- */}
                                    <div className="col-lg-3 col-md-6">
                                        <div className="pd_card h-100">
                                            <div className="pd_header">
                                                <BsShield className="icon" size={22} color="#C63D3D" style={{ marginRight: "10px" }} />
                                                <h4>Program</h4>
                                            </div>

                                            <p><b>Category:</b> {campDetails.categoryName}</p>

                                            <p className="last_dot">
                                                <b>Sub Category:</b>{" "}
                                                {campDetails.subCategory?.map(item => (
                                                    <Fragment key={item._id}>
                                                        {item.name}
                                                        <span>, </span>
                                                    </Fragment>
                                                ))}
                                            </p>

                                            <p><b>Program Type:</b> {campDetails.programType ? getProgramType(campDetails.programType) : ""}</p>

                                            {/* <p><b>Program Code:</b> {campDetails.programCode}</p> */}
                                        </div>
                                    </div>

                                </div>

                                <div className="pd_section_divider"></div>

                                {/* Introduction */}
                                <div className="program_desc_block">
                                    <div className="about_text" 
                                        dangerouslySetInnerHTML={{ __html: cleanHtml(campDetails.aboutProgram) }} />

                                    <div className="intro_text" 
                                        dangerouslySetInnerHTML={{ __html: cleanHtml(campDetails.programIntroduction) }} />
                                </div>
                                <div className="sm_section mt-5">
                                    <h3>Instruction, Equipment & Facility</h3>
                                    <ul>

                                        {campDetails.programInstruction ? <li>Instruction :<p className="ps-4">{getHtml(campDetails.programInstruction)}</p></li> : ''}
                                        {campDetails.equipment ? <li>Equipment Needed : <p className="ps-4">{campDetails.equipment}</p></li> : ''}
                                        {campDetails.facility ? <li>Facility : <p className="ps-4">{campDetails.facility ? getFacility(campDetails.facility) : ''}</p></li> : ''}
                                        
                                        
                                    </ul>
                                </div>

                                {
                                    campDetails.impNotes ? <div className="sm_section">
                                    <h3 className="mb-3">Important Notes</h3>
                                    <p>{getHtml(campDetails.impNotes)}</p>
                                </div> : ''
                                }
                                

                                {TRAVEL_NEEDS_INFO.includes(campDetails.travel) ?
                                    <div className="sm_section">
                                        <h3 className="mb-3">Travel Info </h3>
                                        <p>{campDetails.travelInfo ? getHtml(campDetails.travelInfo) : ''}</p>
                                    </div>:''
                                }

                                {campDetails.additionalExp !== undefined && campDetails.additionalExp.length > 0 ?
                                    <div className="sm_section">
                                        <h3>Additional Experience <OverlayTrigger
                                                                    placement="right"
                                                                    delay={{ show: 50, hide: 250 }}
                                                                    overlay={<Tooltip>Additional Experiences can be added in checkout.</Tooltip>}>
                                                                    <i style={{verticalAlign: 'middle'}} className="icon-information" />
                                                                </OverlayTrigger>
                                        </h3>
                                        {
                                            campDetails.additionalExp ? campDetails.additionalExp.map((item, index) => (
                                                <div style={{color: item.color}} className="additionalExp" key={item._id}>
                                                    <h5 style={{color: item.color}}>{getHtml(item.title)}</h5>
                                                    <p style={{color: item.color}} className="mb-2"><b style={{color: item.color}}>Price :</b> ${item.price}</p>
                                                    {/* <p style={{color: item.color}} className="mb-2"><b style={{color: item.color}}>Available Slots :</b> {item.remainingAdditionalExpCount}</p> */}
                                                    <p><div><b style={{color: item.color}}>Description</b></div> {getHtml(urlify(item.description))}</p>
                                                </div>
                                            )) : ''
                                        }
                                    </div>:''
                                }
                            </div>

                        </div>
                        <div className="col-lg-4">
                            <Row>
                                <Col>
                                
                                {campDetails.isOnline ? 
                                    (<h2 className="cm_on_line">Online Program</h2>)
                                    :
                                    (<div className="camp_detail_map">
                                        { campDetails.geoLocation ? <MapComponent geoLocation={campDetails.geoLocation} {...props} /> : ''}
                                        
                                        <div className="camp_detail_address">
                                            {campDetails.city ? <p className="m-0">{`${campDetails.addressLine1} ${campDetails.city} ${campDetails.state}`}</p> : ''}
                                        </div>
                                    </div>)}
                                </Col>
                            </Row>
                            
                            {/* STICKY SCROLLABLE SIDE BAR */}
                            {!isMobile && !isTablet && (
                                <div className="sticky_sidebar">

                                    <div className="sticky_card_header">
                                        <h3>Registration Options</h3>

                                        {/* byDates programs carry their prices in additionalDates and come back with
                                            registrationFee 0, so gating on registrationFee alone hid this block for them. */}
                                        {campDetails.registrationFee || showByDatesPrice ? (
                                            <div className="starting_price_block">
                                                <small className="starting_from_text">Starting from</small>

                                                <div className="starting_amount">
                                                    ${
                                                        byDates === 1
                                                            ? byDatesStartingFrom.toFixed(2)
                                                            : (() => {
                                                                const reg = overnightTotal || Infinity;

                                                                // If there is no commuter option → overnight is the only price
                                                                if (!hasCommuter) {
                                                                    return reg.toFixed(2);
                                                                }

                                                                return Math.min(reg, commuterTotal).toFixed(2);
                                                            })()
                                                    }
                                                </div>
                                            </div>
                                        ) : null}

                                    </div>

                                    <p className="sticky_sub">Choose your experience</p>
                                    {byDates === 1 ? (
                                        <div className="sticky_dates">
                                            {additionalDates.map((item, i) => (
                                                <label key={i} className="sticky_option">
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedDates.includes(item)}
                                                        onChange={() => onChangeSelectedDates(item)}
                                                    />
                                                    <div className="option_text">
                                                        <span>{gerFavprogrmdateFromFormatted(item.startDateFormatted, item.endDateFormatted)}</span>
                                                        <b>${datePriceWithFee(item).toFixed(2)}</b>
                                                    </div>
                                                </label>
                                            ))}
                                            {nonRefundFee > 0 && (
                                                <small className="date_fee_note">
                                                    Includes a ${nonRefundFee.toFixed(2)} non-refundable registration fee, charged once per camper.
                                                </small>
                                            )}
                                        </div>
                                    ) : (
                                        <div className="sticky_dates">

                                            {/* Overnight Camp */}
                                            { campDetails.disableOvernight !== true && (
                                                <div 
                                                    className={`sticky_option ${selectedExperience === "overnight" ? "selected_ex" : ""}`}
                                                    onClick={() => {
                                                        if (optionCount === 1) {
                                                            // Only one option → go directly to cart
                                                            props.loggedIn
                                                                ? handleRegister({ programDetailIsCommuter: false })
                                                                : props.viewLoginModalAction();
                                                        } else {
                                                            // Toggle selection
                                                            setSelectedExperience(prev =>
                                                                prev === "overnight" ? null : "overnight"
                                                            );
                                                        }
                                                    }}
                                                >
                                                    <div className="option_icon">
                                                        <GiCampfire size={22} color="#C63D3D" />
                                                    </div>

                                                    <div className="option_text">
                                                        <span className="option_title">Overnight Camp</span>

                                                        <div className="price_row">
                                                            <b>${overnightTotal.toFixed(2)}</b>
                                                            <span className="desc_text"> - Full camp experience</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Commuter Option */}
                                            { hasCommuter && (
                                                <div 
                                                    className={`sticky_option ${selectedExperience === "commuter" ? "selected_ex" : ""}`}
                                                    onClick={() => {
                                                        if (optionCount === 1) {
                                                            // Only one → direct redirect
                                                            props.loggedIn
                                                                ? handleRegister({ programDetailIsCommuter: true })
                                                                : props.viewLoginModalAction();
                                                        } else {
                                                            // Toggle selection
                                                            setSelectedExperience(prev =>
                                                                prev === "commuter" ? null : "commuter"
                                                            );
                                                        }
                                                    }}
                                                >
                                                    <div className="option_icon">
                                                        <FaUser size={22} color="#C63D3D" />
                                                    </div>

                                                    <div className="option_text">
                                                        <span className="option_title">Commuter Option</span>

                                                        <div className="price_row">
                                                            <b>${commuterTotal.toFixed(2)}</b>
                                                            <span className="desc_text"> - Day program only</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                        </div>



                                    )}

                                    {/* REGISTER NOW Button */}
                                    <button 
                                        className="sticky_btn w-100"
                                        onClick={() => {
                                            let isCommuterSelected = null;

                                            // user selected commuter
                                            if (selectedExperience === "commuter") {
                                                isCommuterSelected = true;
                                            }

                                            // user selected overnight
                                            else if (selectedExperience === "overnight") {
                                                isCommuterSelected = false;
                                            }

                                            // else → user did NOT pick anything  
                                            // keep existing programDetailIsCommuter default behavior

                                            handleMultiDateCheck(() =>
                                                props.loggedIn 
                                                    ? handleRegister(
                                                        isCommuterSelected !== null 
                                                            ? { programDetailIsCommuter: isCommuterSelected }
                                                            : {}   // no selection → preserve old default behavior
                                                    )
                                                    : props.viewLoginModalAction()
                                            );
                                        }}
                                    >
                                        Register Now
                                    </button>


                                </div>
                            )}

                        </div>

                    </div>
                        
                    {/* {
                        (todayDate2 < campDetails.dateLateRegisterClosed && campDetails.status === 1)
                            ? <div className="mt-5 text-center">
                
                            {
                                                isConfirmed ? <Link to="/cart" className="btn btn-primary btn-sm ms-1 rounded-0">Proceed to checkout</Link> : (
                                                    <React.Fragment>
                                                        <button
                                                            onClick={() => props.loggedIn ? addtocartAction(campDetails._id, numberofCampers, "addtocart") : props.viewLoginModalAction()}
                                                            className={`btn btn-info  btn-sm me-1 rounded-0 ${btnloder ? 'btnLoader' : ''}`}>Add to Cart</button>
                                                        {isAddedToCart ? <Link to="/cart" className="btn btn-primary btn-sm ms-1 rounded-0">Check out</Link> : <button onClick={() => props.loggedIn ? addtocartAction(campDetails._id,numberofCampers, "proceedTocheckout") : props.viewLoginModalAction()} className="btn btn-primary btn-sm ms-1 rounded-0">Check out</button>}
                                                    </React.Fragment>
                                                )
                                            }
                            </div> : (todayDate2 < campDetails.registerCloseDate && campDetails.status === 1) ? <div className="mt-5 text-center">
                
                {
                                    isConfirmed ? <Link to="/cart" className="btn btn-primary btn-sm ms-1 rounded-0">Proceed to checkout</Link> : (
                                        <React.Fragment>
                                            <button
                                                onClick={() => props.loggedIn ? addtocartAction(campDetails._id, numberofCampers, "addtocart") : props.viewLoginModalAction()}
                                                className={`btn btn-info  btn-sm me-1 rounded-0 ${btnloder ? 'btnLoader' : ''}`}>Add to Cart</button>
                                            {isAddedToCart ? <Link to="/cart" className="btn btn-primary btn-sm ms-1 rounded-0">Check out</Link> : <button onClick={() => props.loggedIn ? addtocartAction(campDetails._id,numberofCampers, "proceedTocheckout") : props.viewLoginModalAction()} className="btn btn-primary btn-sm ms-1 rounded-0">Check out</button>}
                                        </React.Fragment>
                                    )
                                }
                </div> : ''
                    } */}

                    


                </div>


                <div id="associated_section" className="associated_wrapper">
                    <div className="container">
                        <div className="d-flex justify-content-between">
                            <h2>Associated Programs</h2>
                            <Link  to={
                            {     
                                pathname: '/associateprograms',
                                state:{"campId":campDetails.campId}
                            }
                        } className="cm_see_All"><h2>See all</h2></Link>
                        </div>

                        <div className="row">
                            {campPrograms.length ? campPrograms.slice(0, 2).map(item => (
                                <div className="col-lg-6" key={item._id}>
                                    <AssociatedCard  UserID={props.userID} data={item} />
                                </div>
                            )) : ''}
                            
                        </div>
                    </div>
                </div>




                <div className="other_detail">
                    <div className="container">

                        <div className="row">

                            {/* <div className="col-lg-12 cm_border_right pe-5"> */}
                            <div className="col-lg-6 pe-5">
                                <h3 className="mb-4">Staff Personnel</h3>
                                <ul>
                                    {
                                        others.map(item => (
                                            <li key={item._id}>
                                                <img src={item.profileImage ? item.profileImage : CampsUser} />
                                                <h6>{item.UserType === 4 ? item.userTitle ? item.userTitle : 'Counselor' : 'Camp Director'}</h6>
                                                <h4 className="mb-2">{item.name}</h4>
                                                <p>{item.userDescription}</p>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>


                            <div className="col-lg-6 ps-5 ">
                                <div className="mb-4 d-flex justify-content-between">
                                <h3>Reviews</h3>
                                <h3 className="color_black cm_cursor" onClick={() => setViewAllModal(true)}>See All</h3>
                                </div>
                                {reviews.length ? <Fragment>
                                    <h4>Total average score : <span className="view_rating"><Rate value={averageCampRating} disabled={true} /></span></h4>
                                
                                    {reviews.slice(0, 3).map(item => (
                                        <div className="review_sm_card">
                                            <img src={item.profileImage ? item.profileImage : CampsUser} />
                                            <h6>{item.username}</h6>
                                            <p>{item.reviews}</p>
                                            <div className="ratings">
                                            <span className="view_rating"><Rate value={item.rating} disabled={true} /></span>
                                            </div> {parseFloat(item.rating).toFixed(1)}
                                        </div>
                                    ))}
                                </Fragment> : <div className="cm_empty"><Empty description="No Reviews Found" /></div>}
                                


                            </div>




                        </div>
                    </div>
                </div>


                {
                    props.loggedIn ?  <div className="ask_quition">
                    <div className="container">
                            <div className="form-group">
                                <label>Ask a question?</label>
                                <textarea
                                    value={question}
                                    onChange={e => setQuestion(e.target.value)}
                                    className="form-control" />
                            </div>

                            <div className="text-center mb-5">
                                <span onClick={handleQuestionSubmit} className={`btn btn-primary rounded-0 ps-5 pe-5 ${btnDisable ? 'disabled' : ''}`}>Submit</span>
                            </div>
                    </div>
                </div> : ''
                }

            






                <div className="donate_sec container">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6">
                                <h2>Make a Donation</h2>
                                <p>These donations go to the specified program provider. Every donation helps, and can allow organizations to fill unmet needs and support the community.  We all, would like to thank you for your generosity!</p>
                                
                                <Link to={`/donate/${campDetails._id}`} className="btn btn_white mt-3">Donate</Link>
                            </div>
                            
                        </div>

                        </div>
                        
                                {SCHOLARSHIP_HAS_URL.includes(scholarships) ? <div className="scholarships_bg" style={{backgroundImage: `url(${Scholarships_bg})`}}><div className="mt-4">
                                    <a href={scholarshipsUrl} className="btn btn-secondary ps-5 pe-5 rounded-0" target="_blank">Apply for scholarship</a>
                                    <p>To apply to need-based financial aid for this program click the Apply button. This financial aid can apply to some, or all, of the registration fee for this program, and acceptance is based solely on the program provider's discretion.</p>
                                </div></div> : ''}
                            
                        
                        
                        
                    
                </div>




                <Modal
                    show={viewAllModal}
                    animation={false}
                    size="lg"
                    centered
                    >
                    <Modal.Body>
                        <span className="modal_close" onClick={() => setViewAllModal(false)}><i className="icon-cross" /></span>
                        

                        <div className="mb-4">
                            <h3>Review</h3>
                            </div>
                            
                                {reviews.length ? <Fragment>
                                    <h4>Total average score : <span className="view_rating"><Rate value={averageCampRating} disabled={true} /></span></h4>
                                    <div className="review_max_height">
                                    {reviews.map(item => (
                                        <div className="review_sm_card">
                                            <img src={item.profileImage ? item.profileImage : CampsUser} />
                                            <h6>{item.username}</h6>
                                            <p>{item.reviews}</p>
                                            <div className="ratings">
                                            <span className="view_rating"><Rate value={item.rating} disabled={true} /></span>
                                            </div> {parseFloat(item.rating).toFixed(1)}
                                        </div>
                                    ))}
                                    </div>
                                </Fragment> : <div className="cm_empty"><Empty description="No Reviews Found" /></div>}
                            
                    </Modal.Body>
                    </Modal>



                    {
                    setting.api.sportInternationalCamp === campDetails.campId ? <a className='providesupport' href="https://vm.providesupport.com/0c628irp4d8370wooul2pwrdfy" target="_blank"><img src="https://image.providesupport.com/image/0c628irp4d8370wooul2pwrdfy/current"  alt="Live chat" title="Click to chat"/></a> : ''
                    }


            </div>
            {/* MOBILE FLOATING BUTTON */}
            {isPhone && isFloating && !showMobileReg && (
                <div
                    className="mobile_reg_fab"
                    onClick={() => setShowMobileReg(true)}
                >
                    Register<br/>Now
                </div>
            )}

            {/* TABLET FLOATING BUTTON */}
            {isTablet && isBigScreenFloating && !showMobileReg && (
                <div
                    className="mobile_reg_fab"
                    onClick={() => setShowMobileReg(true)}
                >
                    Register<br/>Now
                </div>
            )}

            {/* Collapsible Panel ( Register Now ) => Mobile View */}
            <Modal
                show={showMobileReg}
                onHide={() => setShowMobileReg(false)}
                centered
                animation={true}
            >
                <Modal.Body>
                    <span 
                        className="modal_close"
                        onClick={() => setShowMobileReg(false)}
                    >
                        <i className="icon-cross" />
                    </span>

                    {/* ----------------- HEADER + STARTING PRICE ----------------- */}
                    <h3>Registration Options</h3>

                    {/* Displaying the minimum price out of all the options. Same visibility guard as
                        the desktop sidebar — without it a byDates program whose blocks are all sold
                        out or past rendered "Starting from $Infinity" here. */}
                    {campDetails.registrationFee || showByDatesPrice ? (
                        <div className="starting_price_block mb-3">
                            <small className="starting_from_text">Starting from</small>
                            <div className="starting_amount">
                                ${
                                    byDates === 1
                                        ? byDatesStartingFrom.toFixed(2)
                                        : (() => {
                                            const reg = overnightTotal || Infinity;

                                            // If there is no commuter option → overnight is the only price
                                            if (!hasCommuter) {
                                                return reg.toFixed(2);
                                            }

                                            return Math.min(reg, commuterTotal).toFixed(2);
                                        })()
                                }
                            </div>
                        </div>
                    ) : null}

                    <p className="sticky_sub">Choose your experience</p>

                    {/* ----------------- IF MULTIPLE DATES ----------------- */}
                    {byDates === 1 ? (
                        <div className="sticky_dates">
                            {additionalDates.map((item, i) => (
                                <label key={i} className="sticky_option">
                                    <input
                                        type="checkbox"
                                        checked={selectedDates.includes(item)}
                                        onChange={() => onChangeSelectedDates(item)}
                                    />
                                    <div className="option_text">
                                        <span>{gerFavprogrmdateFromFormatted(item.startDateFormatted, item.endDateFormatted)}</span>
                                        <b>${datePriceWithFee(item).toFixed(2)}</b>
                                    </div>
                                </label>
                            ))}
                            {nonRefundFee > 0 && (
                                <small className="date_fee_note">
                                    Includes a ${nonRefundFee.toFixed(2)} non-refundable registration fee, charged once per camper.
                                </small>
                            )}
                        </div>
                    ) : (
                        /* ----------------- IF ONLY SINGLE DATE ----------------- */
                        <div className="sticky_experience_list">

                        {/* Overnight Camp */}
                        { campDetails.disableOvernight !== true && (
                            <div 
                                className={`sticky_option ${selectedExperience === "overnight" ? "selected_ex" : ""}`}
                                onClick={() => {
                                    if (optionCount === 1) {
                                        // Only one option → go directly to cart
                                        props.loggedIn
                                            ? handleRegister({ programDetailIsCommuter: false })
                                            : props.viewLoginModalAction();
                                    } else {
                                        // Toggle selection
                                        setSelectedExperience(prev =>
                                            prev === "overnight" ? null : "overnight"
                                        );
                                    }
                                }}
                            >
                                <div className="option_icon">
                                    <GiCampfire size={22} color="#C63D3D" />
                                </div>

                                <div className="option_text">
                                    <span className="option_title">Overnight Camp</span>

                                    <div className="price_row">
                                        <b>${overnightTotal.toFixed(2)}</b>
                                        <span className="desc_text"> - Full camp experience</span>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Commuter Option */}
                        { hasCommuter && (
                            <div 
                                className={`sticky_option ${selectedExperience === "commuter" ? "selected_ex" : ""}`}
                                onClick={() => {
                                    if (optionCount === 1) {
                                        // Only one → direct redirect
                                        props.loggedIn
                                            ? handleRegister({ programDetailIsCommuter: true })
                                            : props.viewLoginModalAction();
                                    } else {
                                        // Toggle selection
                                        setSelectedExperience(prev =>
                                            prev === "commuter" ? null : "commuter"
                                        );
                                    }
                                }}
                            >
                                <div className="option_icon">
                                    <FaUser size={22} color="#C63D3D" />
                                </div>

                                <div className="option_text">
                                    <span className="option_title">Commuter Option</span>

                                    <div className="price_row">
                                        <b>${commuterTotal.toFixed(2)}</b>
                                        <span className="desc_text"> - Day program only</span>
                                    </div>
                                </div>
                            </div>
                        )}

                        </div>
                    )}

                    {/* ----------------- REGISTER NOW BUTTON ----------------- */}
                    <button 
                        className="sticky_btn w-100"
                        onClick={() => {
                            let isCommuterSelected = null;

                            // user selected commuter
                            if (selectedExperience === "commuter") {
                                isCommuterSelected = true;
                            }

                            // user selected overnight
                            else if (selectedExperience === "overnight") {
                                isCommuterSelected = false;
                            }

                            // else → user did NOT pick anything  
                            // keep existing programDetailIsCommuter default behavior

                            handleMultiDateCheck(() =>
                                props.loggedIn 
                                    ? handleRegister(
                                        isCommuterSelected !== null 
                                            ? { programDetailIsCommuter: isCommuterSelected }
                                            : {}   // no selection → preserve old default behavior
                                    )
                                    : props.viewLoginModalAction()
                            );
                        }}
                    >
                        Register Now
                    </button>

                </Modal.Body>
            </Modal>
        </>

   )
}




/*******************************
    Store Connect
********************************/

const mapStateToProps = state => {
    let { programDetail, preList } = state.program;
    let { mapViewModal } = state.ui;
    let { loggedIn, userProfile } = state.user;
    let userID =false;

    if(state.user.userProfile!== undefined)
    {
        userID = state.user.userProfile._id;
    }
    return {
        mapViewModal,
        programDetail,
        preList,
        loggedIn,
        userID,
        userProfile
    };
}


const mapDispatchToProps = dispatch => ({
    toggleMapViewModal: () => dispatch(toggleMapViewModal()),
    viewLoginModalAction: () => dispatch(viewLoginModalAction()),
    getitemsincart: (cartitems) => dispatch(getitemsincart(cartitems)),
    campContectAction: data => dispatch(campContectAction(data)),
});

  
export default connect(mapStateToProps, mapDispatchToProps)(CampDetail);
